<template>
  <div class="contrato-assinantes">
    <div class="d-flex justify-content-between w-full align-items-center mb-2">
      <h5>Ordem de assinaturas</h5>
    </div>

    <!-- Lista de assinantes com funcionalidade de arrastar e soltar -->
    <draggable
      v-model="rows"
      handle=".drag-handle"
      :animation="150"
      :move="onMove"
    >
      <transition-group>

        <!-- Cada Linha representa um assinante. Arraste para reordenar. -->
        <div
          v-for="(row, index) in rows"
          :key="row.internalId"
          :class="'row-item p-1 mb-1 d-flex align-items-top flex-wrap' + (row.id !== null && getStatusLabel(row.statusAssinante) == 'Assinado' ? ' border assinado-sucesso' : '')"
        >
          <!-- Linha principal com controles -->
          <div class="w-100 d-flex align-items-center">

            <!-- Handle de arrastar e número da ordem -->
            <div class="d-flex align-items-center">
              <span
                v-if="row.id === null || row.id === undefined"
                class="drag-handle mr-2"
                title="Arrastar para reordenar"
                style="cursor:grab;"
              >
                ☰
              </span>

              <!-- <div
                class="mr-3"
                style="min-width:40px"
              >
                <strong>{{ row.ordem || (index + 1) }}</strong>
              </div> -->
            </div>

            <div
              class="mr-3"
              style="min-width:120px"
            >
              <!-- Tipo de Assinante -->
              <b-form-select
                v-model="row.tipoAssinante"
                :options="tipoAssinanteOptions"
                :class="row.id != null ? 'cursor-pointer' : ''"
                :disabled="row.id != null"
              />
            </div>
            <div class="flex-grow-1">
              <b-form-input
                v-model="row.email"
                class="cursor-pointer"
                placeholder="Digite o email do assinante"
                :readonly="row.id != null"
                :state="getEmailState(row)"
                @input="val => setSignerEmail(row, val)"
                @blur="() => setSignerEmail(row, row.email)"
              />
              <b-form-invalid-feedback v-if="getEmailState(row) === false">
                Email inválido
              </b-form-invalid-feedback>
              <div
                v-if="getStatusLabel(row.statusAssinante) != 'Assinado' && row.tokenVerificacao"
              >
                <b-button
                  size="sm"
                  variant="link"
                  class="p-0"
                  @click="copyLink(row)"
                >
                  Copiar Link de Assinatura
                </b-button>
              </div>
            </div>

            <div
              v-if="row.id !== null && getStatusLabel(row.statusAssinante) == 'Assinado'"
              class="ml-2"
            >
              <b-button
                class="btn btn-sm btn-outline-secondary"
                variant="outline-secondary"
                @click="toggleExpanded(row)"
              >
                <feather-icon
                  v-if="expandedStates[row.internalId]"
                  icon="ChevronUpIcon"
                  size="16"
                />
                <feather-icon
                  v-else
                  icon="ChevronDownIcon"
                  size="16"
                />
              </b-button>
            </div>

            <div class="ml-3">
              <b-button
                class="btn btn-sm btn-outline-danger"
                variant="outline-danger"
                @click="removeRow(index)"
              >
                <feather-icon icon="TrashIcon" />
              </b-button>
            </div>
          </div>

          <!-- Painel expandido para editar detalhes -->
          <b-collapse
            v-if="row.id !== null && getStatusLabel(row.statusAssinante) == 'Assinado'"
            :id="'collapse-' + row.internalId"
            :visible="expandedStates[row.internalId]"
            class="expanded-panel p-2 border-top mt-1 bg-light w-100"
          >
            <!-- Campos comuns para Sócio, Interno e Testemunha -->
            <b-form-group label="Nome">
              <b-form-input
                :value="row.nomeAssinante || row.nome"
                :readonly="row.id != null"
              />
            </b-form-group>

            <b-form-group label="Email">
              <b-form-input
                :value="row.email"
                :readonly="row.id != null"
              />
            </b-form-group>

            <!-- <b-form-group label="Telefone">
              <b-form-input
                :value="row.telefone"
                :readonly="row.id != null"
              />
            </b-form-group> -->
            <b-form-group
              v-if="row.id === null || row.id === undefined"
              label="Tipo Inscrição"
            >
              <b-form-select
                :value="row.tipoInscricao"
                :options="[{ value: 'CPF', text: 'CPF' }, { value: 'CNPJ', text: 'CNPJ' }]"
                @input="val => onTipoInscricaoSelected(row, val)"
              />
            </b-form-group>
            <b-form-group :label="`Inscrição (${row.tipoInscricao || 'CPF'})`">
              <b-form-input
                :value="formatInscricao(row.inscricao, row.tipoInscricao)"
                :readonly="row.id != null"
                @input="val => row.inscricao = val.replace(/\D/g, '')"
              />
            </b-form-group>

            <b-form-group
              v-if="row.id !== null && row.id !== undefined"
              label="Status"
            >
              <b-form-input
                :value="getStatusLabel(row.statusAssinante)"
                readonly
              />
            </b-form-group>
          </b-collapse>
        </div>
      </transition-group>
    </draggable>
    <div>
      <b-button
        v-if="!documento || documento.status !== 2"
        class="btn hover:bg-light mt-2"
        variant="outline-primary"
        @click="addRow"
      >
        Adicionar
      </b-button>
    </div>
  </div>
</template>

<script>
import draggable from 'vuedraggable'

export default {
  name: 'ContratoAssinaturas',
  components: {
    draggable,
  },
  props: {
    value: {
      type: [Array, Object],
      default: () => ({}),
    },
    documento: {
      type: [Object, null],
      default: null,
    },
  },
  data() {
    return {
      rows: [],
      updatingFromValue: false,
      expandedStates: {},
      nextInternalId: 1,
      tipoAssinanteOptions: [
        { value: 'Signatario', text: 'Signatário' },
        { value: 'Testemunha', text: 'Testemunha' },
      ],
      hasInvalidEmails: false,
      updatingOrdem: false,
    }
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(newVal) {
        this.syncRowsFromValue(newVal)
      },
    },
    rows: {
      deep: true,
      handler() {
        this.emitRows()
      },
    },
  },
  methods: {
    syncRowsFromValue(source) {
      this.updatingFromValue = true
      const incoming = this.extractIncomingRows(source)

      if (!incoming.length) {
        const freshRow = this.createEmptyRow()
        this.rows = [freshRow]
        this.syncExpandedStates(this.rows)
        this.$nextTick(() => {
          this.updatingFromValue = false
        })
        return
      }

      const mapped = incoming.map((item, index) => this.buildRow(item, this.rows[index]))
      this.rows = mapped
      this.syncExpandedStates(mapped)
      this.$nextTick(() => {
        this.updatingFromValue = false
      })
    },

    extractIncomingRows(source) {
      if (!source) return []
      if (Array.isArray(source)) return source
      if (Array.isArray(source.documentoAssinantes)) return source.documentoAssinantes
      return []
    },

    buildRow(raw, existingRow) {
      const internalId = existingRow?.internalId ?? this.generateInternalId()
      this.ensureInternalCounter(internalId)
      return {
        ...raw,
        internalId,
        emailValido: raw && raw.email ? this.isValidEmail(raw.email) : null,
      }
    },
    ensureInternalCounter(id) {
      if (id >= this.nextInternalId) {
        this.nextInternalId = id + 1
      }
    },

    generateInternalId() {
      const id = this.nextInternalId
      this.nextInternalId += 1
      return id
    },

    syncExpandedStates(rows, defaultState = false) {
      const validIds = rows.map(row => row.internalId)
      Object.keys(this.expandedStates).forEach(key => {
        const numericKey = Number(key)
        if (!validIds.includes(numericKey)) {
          this.$delete(this.expandedStates, key)
        }
      })

      rows.forEach(row => {
        if (!(row.internalId in this.expandedStates)) {
          this.$set(this.expandedStates, row.internalId, defaultState)
        }
      })
    },

    emitRows() {
      if (this.updatingFromValue || this.updatingOrdem) return
      // Atualiza ordem apenas se necessário, evitando loop infinito
      let changed = false
      const newRows = this.rows.map((row, index) => {
        const ordem = index + 1
        if (row.ordem !== ordem) {
          changed = true
          return { ...row, ordem }
        }
        return row
      })
      if (changed) {
        this.updatingOrdem = true
        this.rows = newRows
        // re-executa emit após atualizar ordem
        this.$nextTick(() => {
          this.updatingOrdem = false
          this.emitRows()
        })
        return
      }

      // Verifica se há emails inválidos antes de emitir
      const invalid = this.rows.some(row => {
        // exige email válido (não aceita vazio)
        if (!row.email) return true
        return !this.isValidEmail(row.email)
      })

      if (invalid) {
        this.hasInvalidEmails = true
        return
      }

      this.hasInvalidEmails = false

      const documentoAssinantes = this.rows.map(row => this.serializeRow(row))
      if (Array.isArray(this.value)) {
        this.$emit('input', documentoAssinantes)
      } else {
        this.$emit('input', {
          ...this.value,
          documentoAssinantes,
        })
      }
    },

    isValidEmail(value) {
      if (!value) return false
      // Regex simples e eficaz para emails comuns
      const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
      return re.test(String(value).toLowerCase())
    },

    getEmailState(row) {
      // exige email válido: retorna false para vazio ou inválido, true para válido
      if (row.email === undefined || row.email === null) return false
      if (row.email === '') return false
      if (typeof row.emailValido !== 'undefined' && row.emailValido !== null) {
        return !!row.emailValido
      }
      return this.isValidEmail(row.email)
    },

    serializeRow(row) {
      const { internalId, ...rest } = row
      const payload = { ...rest }
      return payload
    },

    toggleExpanded(row) {
      this.$set(this.expandedStates, row.internalId, !this.expandedStates[row.internalId])
    },

    addRow() {
      const newRow = this.createEmptyRow()
      this.rows = [...this.rows, newRow]
      this.$nextTick(() => {
        this.$set(this.expandedStates, newRow.internalId, true)
      })
    },

    createEmptyRow() {
      const internalId = this.generateInternalId()
      this.ensureInternalCounter(internalId)
      const base = {
        internalId,
        tipoAssinante: 'Signatario',
        email: '',
        emailValido: null,
      }
      return base
    },
    // Prevent moving items that are existing signers (have an id)
    onMove(evt) {
      const dragged = evt.draggedContext && evt.draggedContext.element
      const related = evt.relatedContext && evt.relatedContext.element
      // If either dragged or target item has an id (existing signer), disallow move
      if ((dragged && (dragged.id !== null && dragged.id !== undefined)) || (related && (related.id !== null && related.id !== undefined))) {
        return false
      }
      return true
    },
    setSignerEmail(row, email) {
      const idx = this.findRowIndex(row)
      if (idx === -1) return

      const clean = typeof email === 'string' ? email.trim() : email
      const updated = {
        ...this.rows[idx],
        email: clean,
        emailValido: this.isValidEmail(clean),
      }
      this.$set(this.rows, idx, updated)
    },
    onTipoInscricaoSelected(row, value) {
      const idx = this.findRowIndex(row)
      if (idx === -1) return

      const updated = {
        ...this.rows[idx],
        tipoInscricao: value,
      }
      this.$set(this.rows, idx, updated)
    },

    removeRow(index) {
      const removed = this.rows[index]
      this.rows.splice(index, 1)
      if (removed) {
        this.$delete(this.expandedStates, removed.internalId)
      }
    },

    findRowIndex(row) {
      return this.rows.findIndex(item => item.internalId === row.internalId)
    },

    formatInscricao(value, tipo) {
      if (!value) return value
      const cleanValue = value.replace(/\D/g, '')
      if (tipo === 'CPF' && cleanValue.length === 11) {
        return cleanValue.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4')
      }

      if (tipo === 'CNPJ' && cleanValue.length === 14) {
        return cleanValue.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5')
      }
      return value
    },
    getLinkParaAssinatura(row) {
      if (!this.documento || !row.tokenVerificacao) return null
      const baseUrl = window.location.origin
      return `${baseUrl}/assinatura/${this.documento.id}?token=${row.tokenVerificacao}`
    },
    async copyLink(row) {
      const link = this.getLinkParaAssinatura(row)
      if (!link) {
        if (this.$bvToast) {
          this.$bvToast.toast('Link não disponível', { title: 'Aviso', variant: 'warning', solid: true })
        }
        return
      }

      try {
        if (navigator.clipboard && navigator.clipboard.writeText) {
          await navigator.clipboard.writeText(link)
        } else {
          const ta = document.createElement('textarea')
          ta.value = link
          ta.style.position = 'fixed'
          ta.style.left = '-9999px'
          document.body.appendChild(ta)
          ta.select()
          document.execCommand('copy')
          document.body.removeChild(ta)
        }

        if (this.$bvToast) {
          this.$bvToast.toast('Link copiado para a área de transferência', { title: 'Sucesso', variant: 'success', solid: true })
        }
      } catch (e) {
        if (this.$bvToast) {
          this.$bvToast.toast('Não foi possível copiar o link', { title: 'Erro', variant: 'danger', solid: true })
        }
      }
    },
    getStatusLabel(status) {
      const labels = {
        0: 'Pendente',
        1: 'Visualizado',
        2: 'Assinado',
        3: 'Recusado',
      }
      return labels[status] || 'Desconhecido'
    },
  },
}
</script>

<style scoped>
/* Compact row styling and remove default card shadow */
.contrato-assinantes .row-item {
  width: 100%;
  box-shadow: none;
  border: 1px solid rgba(0, 0, 0, 0.06);
  border-radius: 4px;
  padding: 6px 8px;
  margin-bottom: 6px;
  align-items: center;
}
.contrato-assinantes .row-item .drag-handle {
  font-size: 14px;
  line-height: 1;
  margin-right: 8px;
}
.contrato-assinantes .row-item strong {
  font-size: 0.9rem;
}
.contrato-assinantes .row-item .form-control.form-control-sm {
  height: calc(1.2rem + 6px);
  padding: .15rem .35rem;
  font-size: .85rem;
}
.contrato-assinantes .btn {
  font-size: .8rem;
  padding: .25rem .5rem;
}
.assinado-sucesso {
  border-color: #44f36d !important;
  background-color: #e6f4ea;
}
.cursor-pointer {
  cursor: pointer;
}
</style>
